import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import io from 'socket.io-client';

/*
  Generated class for the WebSocketServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WebSocketService {
  // 最新の状態変化
  private currentInfoSource = new Subject<any>();
  currentInfo$ = this.currentInfoSource.asObservable();

  // アラート受信
  private alertInfoSource = new Subject<any>();
  alertInfo$ = this.alertInfoSource.asObservable();

  socketio;

  constructor(){}

  connect() {

    // 
    if (this.socketio) {
      console.log('コネクションを再度張り直す');
      this.disConnect();
    }

    // 今回は実装しない
    // ソケットデータのやり取り start
    // TODO: 損保さんへ提供する場合は、こちらのURLに置き換えること！
    this.socketio = io.connect('https://sompocare-api.cdc-iot.com');
    // this.socketio = io.connect('https://test-vitaly-app-api.cdc-iot.com');

    this.socketio.on('connect', () => {
      console.log('websocket connect');
    });

    this.socketio.on('disconnect', () => {
      console.log('websocket disconnect');
    });

    this.socketio.on('currentInfo', (params) => {
      console.log('*** WebSocketイベント受信 ***', 'currentInfo');
      console.log(params);
      this.currentInfoSource.next(params);
    });

    this.socketio.on('alertInfo', (params) => {
      console.log('*** WebSocketイベント受信 ***', 'alertInfo');
      console.log(params);
      if (!params) return ;
      
      if (this.enableNotification()) {
        if (params.alert.type === 'nurseCall') {
          if (params.alert.state === 'START') {
            let message = `${params.roomName}`;
            if (params.alert.place) message = params.alert.place;
            if (params.patientName) {
              message += `の${params.patientName}さん`;
            }
            this.showNotification(`【ナースコール】${params.alert.name}`, `${message}`);
          }
        } else {
          this.showNotification(`【アラート】${params.alert.name}`, `${params.roomName}の${params.patientName}さん`);
        }
      }
      this.alertInfoSource.next(params);
    });


    // ブラウザが通知をサポートしているか確認する
    if (this.enableNotification()) {
      Notification.requestPermission();
    }    
  }

  disConnect() {
    this.socketio.disconnect();
  }

  enableNotification() {
    // ブラウザが通知をサポートしているか確認する
    if (!("Notification" in window)) {
      return false;
    }
    return true;
  }


  notifyMe(title: string, message: string = '') {
    // ブラウザが通知をサポートしているか確認する
    if (!this.enableNotification()) return ;


    // すでに通知の許可を得ているか確認する
    if ((Notification as any).permission === "granted") {

      // 許可を得ている場合は、通知を作成する
      this.showNotification(title, message);

    // 許可を得ていない場合は、ユーザに許可を求めなければならない
    } else if ((Notification as any).permission !== 'denied') {

      (Notification as any).requestPermission((permission) => {
        // ユーザが許可した場合は、通知を作成する
        if (permission === "granted") {
          this.showNotification(title, message);
        }
      });

    } 
  }

  showNotification(title: string, message: string = '') {
    const options = {
        body: message,
        icon: './assets/imgs/logo/cdc_logo.png'
      };
    const n = new Notification(title, options);
    n.onclick = () => {
      // (Notification as any).close();
      console.log('クリックされたよ');
    };
    setTimeout(n.close.bind(n), 5000); 
  }


}



// WEBPACK FOOTER //
// ./src/providers/web-socket.service.ts